#version 300 es
/*
* Preprocessed + Optimized from './hue-rotate.frag'
* [Embedded string is compressed]
*/
precision mediump float;
precision highp int;

uniform mediump sampler2D uTexture;
uniform float angle;
uniform float u_intensity;

in vec2 vTextureCoord;
layout(location = 0) out vec4 fragColor;

void main()
{
    vec4 _101 = texture(uTexture, vTextureCoord);
    float _124 = radians(angle);
    mat4 _129 = mat4(vec4(0.787000000476837158203125, -0.714999973773956298828125, -0.0719999969005584716796875, 0.0), vec4(-0.212999999523162841796875, 0.2849999964237213134765625, -0.0719999969005584716796875, 0.0), vec4(-0.212999999523162841796875, -0.714999973773956298828125, 0.927999973297119140625, 0.0), vec4(0.0, 0.0, 0.0, 1.0)) * cos(_124);
    mat4 _146 = mat4(vec4(-0.212999999523162841796875, -0.714999973773956298828125, 0.927999973297119140625, 0.0), vec4(0.14300000667572021484375, 0.14000000059604644775390625, -0.28299999237060546875, 0.0), vec4(-0.787000000476837158203125, 0.714999973773956298828125, 0.0719999969005584716796875, 0.0), vec4(0.0, 0.0, 0.0, 1.0)) * sin(_124);
    fragColor = mix(_101, _101 * mat4((vec4(0.212999999523162841796875, 0.714999973773956298828125, 0.0719999969005584716796875, 0.0) + _129[0]) + _146[0], (vec4(0.212999999523162841796875, 0.714999973773956298828125, 0.0719999969005584716796875, 0.0) + _129[1]) + _146[1], (vec4(0.212999999523162841796875, 0.714999973773956298828125, 0.0719999969005584716796875, 0.0) + _129[2]) + _146[2], (vec4(0.0, 0.0, 0.0, 1.0) + _129[3]) + _146[3]), vec4(u_intensity));
}
